/* Header component */
export default function Header() {
  return (
    <header className="App-header">
      <img src="img/banner.jpeg" className="App-banner" alt="banner" />
    </header>
  );
}
